import type { AgeFilterOption } from "components/AgeFilter"

export enum DemolitionMoreFiltersKeys {
    AGE = "age",
    AGE_OPTION = "age_op",
    RAISED_BY = "raised_by_id",
    EXECUTED_BY = "assigned_to",
    RAISED_ON_START = "raised_on_start",
    RAISED_ON_END = "raised_on_end",
    RAISED_ON_OPTION = "raised_on_option",
    UPDATED_ON_START = "updated_on_start",
    UPDATED_ON_END = "updated_on_end",
    UPDATED_ON_OPTION = "updated_on_option",
    TAGS = "tag_ids",
    TARGET_CLOSURE_START = "target_closure_start",
    TARGET_CLOSURE_END = "target_closure_end",
    TARGET_CLOSURE_OPTION = "target_closure_option",
    TEMPLATE = "template_id",
    CATEGORY = "category_ids",
    DEMOLITION_REASON = "demolition_reason",
    ON_HOLD = "on_hold",
    ON_HOLD_DATE = "on_hold_date",
    ON_HOLD_REASON_IDS = "on_hold_reason_ids",
}

type DropdownOption = { id: string | number; title: string }

export type DemolitionMoreFiltersType = {
    [DemolitionMoreFiltersKeys.AGE]: number[]
    [DemolitionMoreFiltersKeys.AGE_OPTION]: AgeFilterOption | null
    [DemolitionMoreFiltersKeys.RAISED_BY]: DropdownOption | null
    [DemolitionMoreFiltersKeys.EXECUTED_BY]: DropdownOption | null
    [DemolitionMoreFiltersKeys.RAISED_ON_START]: string
    [DemolitionMoreFiltersKeys.RAISED_ON_END]: string
    [DemolitionMoreFiltersKeys.RAISED_ON_OPTION]: DropdownOption | null
    [DemolitionMoreFiltersKeys.UPDATED_ON_START]: string
    [DemolitionMoreFiltersKeys.UPDATED_ON_END]: string
    [DemolitionMoreFiltersKeys.UPDATED_ON_OPTION]: DropdownOption | null
    [DemolitionMoreFiltersKeys.TAGS]: DropdownOption[]
    [DemolitionMoreFiltersKeys.TARGET_CLOSURE_START]: string
    [DemolitionMoreFiltersKeys.TARGET_CLOSURE_END]: string
    [DemolitionMoreFiltersKeys.TARGET_CLOSURE_OPTION]: DropdownOption | null
    [DemolitionMoreFiltersKeys.TEMPLATE]: DropdownOption[]
    [DemolitionMoreFiltersKeys.CATEGORY]: DropdownOption[]
    [DemolitionMoreFiltersKeys.DEMOLITION_REASON]: DropdownOption[]
    [DemolitionMoreFiltersKeys.ON_HOLD]: DropdownOption | null
    [DemolitionMoreFiltersKeys.ON_HOLD_DATE]: string
    [DemolitionMoreFiltersKeys.ON_HOLD_REASON_IDS]: DropdownOption[]
}

export const INITIAL_MORE_FILTERS: DemolitionMoreFiltersType = {
    [DemolitionMoreFiltersKeys.AGE]: [],
    [DemolitionMoreFiltersKeys.AGE_OPTION]: null,
    [DemolitionMoreFiltersKeys.RAISED_BY]: null,
    [DemolitionMoreFiltersKeys.EXECUTED_BY]: null,
    [DemolitionMoreFiltersKeys.RAISED_ON_START]: "",
    [DemolitionMoreFiltersKeys.RAISED_ON_END]: "",
    [DemolitionMoreFiltersKeys.RAISED_ON_OPTION]: null,
    [DemolitionMoreFiltersKeys.UPDATED_ON_START]: "",
    [DemolitionMoreFiltersKeys.UPDATED_ON_END]: "",
    [DemolitionMoreFiltersKeys.UPDATED_ON_OPTION]: null,
    [DemolitionMoreFiltersKeys.TAGS]: [],
    [DemolitionMoreFiltersKeys.TARGET_CLOSURE_START]: "",
    [DemolitionMoreFiltersKeys.TARGET_CLOSURE_END]: "",
    [DemolitionMoreFiltersKeys.TARGET_CLOSURE_OPTION]: null,
    [DemolitionMoreFiltersKeys.TEMPLATE]: [],
    [DemolitionMoreFiltersKeys.CATEGORY]: [],
    [DemolitionMoreFiltersKeys.DEMOLITION_REASON]: [],
    [DemolitionMoreFiltersKeys.ON_HOLD]: null,
    [DemolitionMoreFiltersKeys.ON_HOLD_DATE]: "",
    [DemolitionMoreFiltersKeys.ON_HOLD_REASON_IDS]: [],
}
